


















import { Component, Vue } from "vue-property-decorator";
import { getNewsList } from "@/req/homes";

@Component({
  components: {},
})
export default class Home extends Vue {
  public list: any = [];
  public size = 10;
  public page = 1;
  public nums = 0;
  public mounted() {
    this.getList();
  }
  public changePage(i) {
    window.scrollTo(0, 0);
    this.page = i;
    this.getList();
  }
  public async getList() {
    const res = await getNewsList({
      page: this.page,
      size: this.size,
      is_seo: this.$route.path == "/996news" ? 1 : 0,
    });
    if (res.code == 200) {
      this.list = res.data.data;
      this.nums = res.data.total;
    }
  }
  public toDetail(ids) {
    const routeUrl = this.$router.resolve({
      path: "/newsDetail",
      query: { id: ids },
    });
    window.open(routeUrl.href, "_blank");
  }
}
